var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button--primary",on:{"click":_vm.openPopup}},[_c('i',{staticClass:"icon fas fa-shopping-basket"}),_vm._v(_vm._s(_vm._f("t")("Order now"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }